import BaseUIERPCreateView from 'xui/modules/erp/BaseUIERPCreateView'
// import { getConfig } from 'x/config/mode'
// import { WebView } from 'react-native-webview'
// import OrdersSummaryDonut from '../../components/OrdersSummaryDonut'

export default class ERPListView extends BaseUIERPCreateView {
  static displayName = 'ERPListView'

  static navigationOptions = {
    header: null,
  }
}
